/* Jubi saved rugs (Oct 12 2026, roadmap step 2).
   Hearts on product cards and product pages. Saving needs an account, like the Customizer's "Save to my account"
   (Cassie, Oct 12): signed in, the app keeps hearts (/apps/customizer/saved-rug; identity is Shopify's signed
   logged_in_customer_id on the proxy). Signed out, a tap goes straight to sign-in (returns to this page); the tapped rug
   is remembered (localStorage) and saved to the account the moment the shopper is back signed in.
   Also sends the Klaviyo "Saved a Rug" event (public key, best effort). window.JubiCustomer is set by layout/theme.liquid. */
(function () {
  var PENDING = 'jubi_saved_pending';   // the rug hearted while signed out, saved on return
  var cust = window.JubiCustomer || {};
  var signedIn = !!cust.id;
  var KLAVIYO = 'VZ7Hz7';
  // A pending heart is honoured for 30 min: someone who backed out of the sign-in and signs in days later for another
  // reason should not find a rug they never meant to keep.
  var pending = function () { try { var d = JSON.parse(localStorage.getItem(PENDING) || 'null'); return d && d.at && Date.now() - d.at < 30 * 60 * 1000 ? d : null; } catch (e) { return null; } };
  var setPending = function (d) { try { if (d) localStorage.setItem(PENDING, JSON.stringify(Object.assign({ at: Date.now() }, d))); else localStorage.removeItem(PENDING); } catch (e) {} };
  var proxy = function (path, opts) { return fetch('/apps/customizer/' + path, Object.assign({ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }, opts || {})); };
  var ids = {};   // handle -> saved item id (signed in)

  var paint = function (btn, on) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.title = on ? 'Saved' : 'Save'; btn.classList.toggle('is-saved', !!on); };
  // ms: confirmations fade after ~3 s; a prompt that asks for a click (Sign in) stays 8 s, and stays while hovered.
  var toast = function (text, href, label, ms) {
    var t = document.querySelector('.jubi-heart-toast'); if (!t) { t = document.createElement('div'); t.className = 'jubi-heart-toast'; document.body.appendChild(t); }
    t.innerHTML = '';
    var s = document.createElement('span'); s.textContent = text; t.appendChild(s);
    if (href) { var a = document.createElement('a'); a.href = href; a.textContent = label || 'View saved'; t.appendChild(a); }
    var hide = function () { t.classList.remove('is-on'); };
    var arm = function (d) { clearTimeout(t._h); t._h = setTimeout(hide, d); };
    if (!t._hover) { t._hover = true; t.addEventListener('mouseenter', function () { clearTimeout(t._h); }); t.addEventListener('mouseleave', function () { arm(2500); }); }
    t.classList.add('is-on'); arm(ms || 3200);
  };
  var klaviyo = function (d) {
    if (!cust.email) return;
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify({ data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: 'Saved a Rug' } } }, profile: { data: { type: 'profile', attributes: { email: cust.email } } }, properties: { product_title: d.title, product_handle: d.handle, image: d.image, price: d.price, link: location.origin + '/products/' + d.handle }, unique_id: 'saved-rug-' + d.handle + '-' + Date.now() } } }) }).catch(function () {});
    } catch (e) {}
  };

  var hearts = function () { return Array.prototype.slice.call(document.querySelectorAll('[data-jubi-heart]')); };
  var dataOf = function (btn) { return { handle: btn.dataset.handle, title: btn.dataset.title, image: btn.dataset.image, price: parseFloat(btn.dataset.price) || null }; };

  // Initial state for every heart on the page
  var init = function () {
    var hs = hearts(); if (!hs.length) return;
    if (!signedIn) return;   // signed out: every heart stays empty — saving needs an account
    var handles = []; hs.forEach(function (b) { if (handles.indexOf(b.dataset.handle) < 0) handles.push(b.dataset.handle); });
    proxy('saved-rug?handles=' + encodeURIComponent(handles.join(','))).then(function (r) { return r.ok ? r.json() : { saved: {} }; }).then(function (j) {
      ids = j.saved || {}; hs.forEach(function (b) { paint(b, !!ids[b.dataset.handle]); });
    }).catch(function () {});
  };

  // Back signed in after tapping a heart while signed out: save that rug now, once.
  var finishPending = function () {
    var d = pending(); if (!d || !d.handle) return; setPending(null); if (!signedIn) return;
    proxy('saved-rug', { method: 'POST', body: JSON.stringify(d) }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (j) { ids[d.handle] = j.id; hearts().forEach(function (b) { if (b.dataset.handle === d.handle) paint(b, true); }); toast('Saved to your account', '/pages/my-designs'); if (!j.already) klaviyo(d); })
      .catch(function () {});
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jubi-heart]'); if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var d = dataOf(btn), on = btn.getAttribute('aria-pressed') === 'true';
    if (!signedIn) {
      // Straight to sign-in (Cassie, Oct 12: no popup). The login returns to this page and the tapped rug saves on arrival.
      setPending(d);
      window.location.href = cust.loginUrl || '/customer_authentication/login';
      return;
    }
    hearts().forEach(function (b) { if (b.dataset.handle === d.handle) paint(b, !on); });
    if (on) {
      var id = ids[d.handle]; if (!id) return;
      proxy('saved?rug=' + encodeURIComponent(id), { method: 'DELETE' }).then(function () { delete ids[d.handle]; toast('Removed from saved'); }).catch(function () { paint(btn, true); });
    } else {
      proxy('saved-rug', { method: 'POST', body: JSON.stringify(d) }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (j) { ids[d.handle] = j.id; toast('Saved to your account', '/pages/my-designs'); if (!j.already) klaviyo(d); })
        .catch(function () { paint(btn, false); toast('Could not save — try again'); });
    }
  }, true);

  // Cards arrive late on collection pages (section rendering, infinite scroll): re-paint new hearts as they appear.
  var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(init, 150); });
  var start = function () { init(); finishPending(); mo.observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
